import ProjectDailyReport from "../pages/Reports/ProjectDailyReport";

const menuTitles = {
  dashboard: "Dashboard",
  user: "Users",
  employee: "Employee",
  client: "Client User",
  project: "Project",
  leaveManagement: "Leave Management",
  leaveSummary: "Leave Summary",
  publicHoliday: "Public Holiday",
  projectReport: "Project Report",
  reverted: "Reverted",
  "time-tracker": "Work Activity",
  "app-usage": "App & Site Usage",
  "note-approvals": "Note Approvals",
  productivity: "Productivity",
  vault: "Vault",
  myEarnedLeaveRequests: "My Compensatory Off Requests",
  editEmployee: "Edit Employee",
  addParentTask: "Add Parent Task",
  taskManagement: "Task Management",
  clientTaskManagement: "Task Management",
  createTask: "Create Task",
  taskDetails: "Task Details",
  employeeDetails: "Employee Details",
  attendance: "Attendance",
  request: "Request",
  supportingFileupload: "Supporting Fileupload",
  clientTaskReport: "Client Task Report",
  projectworkingreport: "Project Working Report",
  parenttaskreport: "Parent Task Report",
  taskreport: "Task Report",
  candidateHistory: "Candidate Report",
  dailyWorkingReport: "Daily Working Report",
  todoTask: "Todo Task",
  parentTask: "Parent Task",
  Manager: "Manager Detail",
  earnedLeaveRequests: "Compensatory Off Requests",
  shifts: "Shifts",
  permissionManagement: "Permission Management",
  issuewisereport: "Issuewise Report",
  appDownloadUpload: "App Download Upload",
  systemMonitoring: "System Monitoring",
  bugManagement: "Bug Management",
  ProjectDailyReport: "Project Working Report",
  DailyWorkingReport: "Daily Working Report",
  payrollManagement: "Payroll Management",
  timeSheet: "Time Sheet",
  timeLoggerOrgs: "TimeLogger Organisations",
  timeLoggerAttendance: "TimeLogger Attendance",
};

export { menuTitles };
